import { styled, Box, BottomNavigation } from "@mui/material";
import { background, divider, primary, text } from "@/theme/colors";

/** Max mobile viewport width — iPhone 16 Pro Max (430px), the largest mainstream phone */
export const MOBILE_MAX_WIDTH = "430px";

/** Outermost shell — white background for area outside mobile content */
export const LayoutShell = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background-color: ${background.white};
`;

/** Content area — constrained to mobile max width, centered, primary background */
export const LayoutRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  max-width: ${MOBILE_MAX_WIDTH};
  width: 100%;
  margin: 0 auto;
  background-color: ${background.primary};
`;

export const SafeAreaTop = styled(Box)`
  padding-top: var(--safe-area-inset-top);
  flex-shrink: 0;
`;

export const MainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 16px;
`;

export const MockExamMainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

/** Bottom nav — constrained to content width, centered, with safe area */
export const BottomNavWrapper = styled(Box)`
  flex-shrink: 0;
  width: 100%;
  max-width: ${MOBILE_MAX_WIDTH};
  margin: 0 auto;
  padding-bottom: var(--safe-area-inset-bottom);
  background-color: ${background.white};
  border-top: 1px solid ${divider.high};
`;

export const StyledBottomNav = styled(BottomNavigation)`
  height: var(--mobile-bottom-nav-height);

  .MuiBottomNavigationAction-root {
    color: ${text.secondary};
    min-width: 0;
    padding: 8px;
    gap: 4px;
    font-family: "Noto Sans JP", sans-serif;

    svg {
      font-size: 28px;
    }

    .MuiBottomNavigationAction-label {
      font-size: 12px;
      font-weight: 500;
      line-height: 170%;

      &.Mui-selected {
        font-size: 12px;
      }
    }

    &.Mui-selected {
      color: ${primary[500]};
    }
  }
`;

export const StandaloneMainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;
